











































































import { ClientAccountsApi } from '@/api/client-accounts';
import loading from '@/components/loading.vue';
import { ClientAccount } from '@/shared/clients/client-account';
import { ClientStatusType } from '@/shared/types/client-status-type';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const partnerPracticesModule = namespace('partnerPractices');
const typesModule = namespace('types');
const clientApi = new ClientAccountsApi();

@Component({
    components: {
        loading,
    },
})
export default class AddPartnerDialog extends Vue {
    @partnerPracticesModule.Getter('partnerPracticeName') private partnerPracticeName!: (partnerPracticeId: string | null) => string;

    @typesModule.Getter('activeClientStatusTypes') private clientStatusTypes!: Array<ClientStatusType>;

    @Prop({ required: true }) public client!: ClientAccount;
    @Prop({ required: true }) public visible!: boolean;

    private isVisible: boolean = this.visible;
    private isLoading: boolean = true;
    private selectedClient: ClientAccount | null = null;
    private currentPage: number = 1;
    private pageSize: number = 10;
    private total: number = 0;
    private clients: Array<ClientAccount> = new Array<ClientAccount>();
    private accountNo: number | null = null;
    private firstName: string | null = null;
    private lastName: string | null = null;

    private get clientFields(): Array<{}> {
        const fields = [
            { key: 'select', label: '', sortable: false },
            { key: 'accountNo', label: 'Account No', sortable: true },
            { key: 'firstName', label: 'First Name', sortable: true },
            { key: 'lastName', label: 'Surname', sortable: true },
            { key: 'dateOfBirth', label: 'Date of Birth', sortable: true },
            { key: 'accountStatus', label: 'Account Status', sortable: true },
            { key: 'partnerPractice', label: 'Assigned To', sortable: true },
            { key: 'address', label: 'Address', sortable: true, thClass: 'col-4' },
        ];

        return fields;
    }

    private get paginationDescription(): string {
        const start = (this.clients.length < 1)
            ? 0
            : ((this.currentPage - 1) * this.pageSize) + 1;

        const end = start + this.pageSize > this.total
            ? this.total
            : start + this.pageSize - 1;

        return `Showing ${start.toLocaleString()} - ${end.toLocaleString()} of ${this.total.toLocaleString()}`;
    }

    private accountStatusDescription(accountStatusId: string | null): string {
        if (accountStatusId == null) {
            return '';
        }

        const type = this.clientStatusTypes.find((t) => t.id === accountStatusId);

        return type == null ? '' : type.value;
    }

    @Watch('visible')
    private onVisibleChanged(visible: boolean): void {
        this.selectedClient = null;
        this.isVisible = visible;
    }

    @Watch('currentPage')
    private async onCurrentPageChanged(): Promise<void> {
        await this.fetchClientsAsync();
    }

    private onCancel(): void {
        this.$emit('cancel');
    }

    private async fetchClientsAsync(): Promise<void> {
        if (!await this.$validator.validateAll()) { return; }

        try {
            this.isLoading = true;

            const result = await clientApi.getClientPotentialPartnersAsync(this.client!.id!, {
                page: this.currentPage,
                pageSize: this.pageSize,
                accountNo: this.accountNo,
                firstName: this.firstName,
                lastName: this.lastName,
            });

            this.clients = result.clients;
            this.total = result.total;
        } catch (e) {
            if (e instanceof Error) {
                this.$snackbar.open({ message: e.message, type: 'is-danger' });
            } else {
                this.$snackbar.open({ message: 'Could not load potential client partners.', type: 'is-danger' });
            }
        }

        this.isLoading = false;
    }

    private onAssign(): void {
        this.$emit('ok', this.selectedClient);
    }

    private onClientSelected(client: ClientAccount | null): void {
        if (this.selectedClient == null || client == null) {
            this.selectedClient = client;
            return;
        }

        if (this.selectedClient.id === client.id) {
            this.selectedClient = null;
        } else {
            this.selectedClient = client;
        }
    }

    private clearFilters(): void {
        this.accountNo = null;
        this.firstName = null;
        this.lastName = null;
    }

    private async mounted(): Promise<void> {
        this.isLoading = true;

        const types = [
            this.$store.dispatch(`partnerPractices/loadPartnerPracticesAsync`),
            this.$store.dispatch(`types/loadTypesAsync`),
            this.$store.dispatch(`types/loadPartnerPracticeTypesAsync`),
        ];

        await Promise.all(types);

        await this.fetchClientsAsync();

        this.isLoading = false;
    }
}
